import React from 'react';
import Banner from '@atlaskit/banner';
import WarningIcon from '@atlaskit/icon/core/warning';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries';
import HelpPanelButton from '@atlassian/jira-help-panel-button';
import { useIntl } from '@atlassian/jira-intl';
import { useIsSiteAdmin } from '@atlassian/jira-tenant-context-controller';
import messages from './messages';

function CipherDeprecationBanner() {
	const { formatMessage } = useIntl();
	const isSiteAdmin = useIsSiteAdmin();

	const mailServerSettingsLink = (
		<HelpPanelButton
			articleId="6bSBVhywj4oQDe7rCDr9tT"
			appearance="subtle-link"
			spacing="none"
			fallbackComponent={<>{formatMessage(messages.mailServerSettingsLink)}</>}
		>
			<Box xcss={linkTextStyles}>{formatMessage(messages.mailServerSettingsLink)}</Box>
		</HelpPanelButton>
	);

	return (
		<JSErrorBoundary
			id="jiraQueueViewCipherDeprecationBanner"
			packageName="jiraSpaAppsServicedeskQueuesAgentView"
			teamName="jsm-fission"
		>
			{isSiteAdmin && (
				<Banner appearance="warning">
					<Box xcss={bannerContainerStyles}>
						<Box>
							<WarningIcon label="Warning" color={token('color.icon.warning.inverse')} />
						</Box>
						<Box>
							{formatMessage(messages.cipherDeprecationMessage, {
								mailServerSettingsLink,
							})}
						</Box>
					</Box>
				</Banner>
			)}
		</JSErrorBoundary>
	);
}

const bannerContainerStyles = xcss({
	display: 'flex',
	columnGap: 'space.100',
});

const linkTextStyles = xcss({
	color: 'color.text.warning.inverse',
	textDecoration: 'underline',
});

export default CipherDeprecationBanner;
